import { render, staticRenderFns } from "./SurveyPreQuestion.vue?vue&type=template&id=1f570c3a&scoped=true&"
import script from "./SurveyPreQuestion.vue?vue&type=script&lang=js&"
export * from "./SurveyPreQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPreQuestion.vue?vue&type=style&index=0&id=1f570c3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f570c3a",
  null
  
)

export default component.exports